module.exports = __webpack_public_path__ + "img/language.4ef6c9ab.svg";